import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIImage from 'UIComponents/image/UIImage';
import { H4 } from 'UIComponents/elements/headings';
// @ts-expect-error Could not find a declaration file for module
import abstractCardImage from 'bender-url!../../../../images/content-empty-icon.svg';
//@ts-expect-error Could not find declaration file for module
import playlistTableUrl from 'bender-url!../../../../images/playlist-table.svg';
import UISection from 'UIComponents/section/UISection';
import BlankPageMediaWrapper from '../../../components/BlankPageMediaWrapper';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useMyPlaylistsParams } from '../../myPlaylists';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SavedItemsEmpty = ({
  itemKey
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const showAssignmentsBlankContent = itemKey === 'myPlaylists';
  const {
    tab
  } = useMyPlaylistsParams();
  return /*#__PURE__*/_jsx(UISection, {
    className: isMobile ? 'm-top-6' : undefined,
    "data-test-id": `${itemKey}-empty`,
    children: /*#__PURE__*/_jsxs(BlankPageMediaWrapper, {
      itemRight: /*#__PURE__*/_jsx(UIImage, {
        src: showAssignmentsBlankContent ? playlistTableUrl : abstractCardImage
      }),
      children: [/*#__PURE__*/_jsx(H4, {
        children: showAssignmentsBlankContent ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.myPlaylists.tab.${tab}.blankHeader`
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.savedItems.${itemKey}.emptyHeading`
        })
      }), /*#__PURE__*/_jsx("p", {
        children: showAssignmentsBlankContent ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `learningCenter.myPlaylists.tab.${tab}.blankBody`
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.savedItems.${itemKey}.emptyBody`
        })
      })]
    })
  });
};
export default SavedItemsEmpty;